export default "__VITE_ASSET__754c6f93__"